var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Title from '../../../atoms/Title';
import Desc from '../../../atoms/Desc';
import { VerticalGap } from '../../../atoms/Gap/Gap';
import CtaBtn from '../../../atoms/CtaBtn';
import { neutralDay, scc } from '@teamsparta/design-system';
import { PUSH, readWriteModalHistoryAtom, Tasks } from '../../../../stores';
import { useAtom } from 'jotai/index';
import { BottomContents, MainContents } from '../../../../styles/_common.style';
import { useIsMobile } from '../../../../businessLogics/hooks';
import { useFetchIsLoggedIn } from '../../../../businessLogics/apis/exports';
var ChangePasswordDone = function (_a) {
    var _b, _c;
    var setIsShow = _a.setIsShow;
    var _d = useAtom(readWriteModalHistoryAtom), _ = _d[0], updateHistory = _d[1];
    var isLoggedIn = useFetchIsLoggedIn();
    var isMobile = useIsMobile();
    var onClickCta = function () {
        var _a;
        if (isLoggedIn.isSuccess && ((_a = isLoggedIn.data) === null || _a === void 0 ? void 0 : _a.is_logined)) {
            setIsShow(false);
        }
        else {
            updateHistory({ action: PUSH, task: Tasks.LOGIN_EMAIL });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 166, isCenterInMobile: true }, { children: [_jsx(Title, { children: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD \uC644\uB8CC!" }), !isLoggedIn.isSuccess && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsx(Desc, { children: "\uB85C\uADF8\uC778\uD558\uB7EC \uAC00\uBCFC\uAE4C\uC694?" })] })), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: onClickCta }, { children: _jsx(_Fragment, { children: isLoggedIn.isSuccess && ((_b = isLoggedIn.data) === null || _b === void 0 ? void 0 : _b.is_logined) ? '닫기' : '로그인하러 가기' }) }))] }))] })), isMobile && (_jsx(BottomContents, { children: _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: onClickCta }, { children: _jsx(_Fragment, { children: isLoggedIn.isSuccess && ((_c = isLoggedIn.data) === null || _c === void 0 ? void 0 : _c.is_logined) ? '닫기' : '로그인하러 가기' }) })) }))] }));
};
export default ChangePasswordDone;
//# sourceMappingURL=ChangePasswordDone.js.map